import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { Validators } from '@angular/forms';

export const ecNoOnlyWhiteSpacesValidator = (control: AbstractControl): ValidationErrors | null => {
  const errors: { [key: string]: boolean } = {};
  if (control.value) {
    console.log('control.value', control.value);
    const isWhitespace = control.value.trim().length === 0;
    if (isWhitespace) {
      errors['noOnlyWhiteSpaces'] = true;
    }
  }
  return errors;
};

export const nameValidators = [
  Validators.minLength(1),
  Validators.maxLength(50),
  ecNoOnlyWhiteSpacesValidator,
];
